var menuState = false;
var dropState = false;

$(document).ready(function () {
  // 初期化
  sNavOut(".header__nav");

  // swiper
  if ($(".detailSlider").length) {
    //商品詳細ページスライダー
    let detailSlider = new Swiper(".detailSlider", {
      effect: "slide",
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 900,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    var variantRadios = document.querySelectorAll(".variant_select input");
    for (var i = 0; i < variantRadios.length; i++) {
      variantRadios[i].addEventListener("change", function () {
        // 選択されたバリエーションに応じてSwiper.jsのスライドを変更する
        detailSlider.slideTo(Number(3 * $(this).attr("data-index") - 2));
      });
    }

    //カラーチップの選択状況に合わせて、詳細スライダーを変更
    let $colorSelected = $(".product-form__input input[type='radio']:checked");
    let target_index = $colorSelected.data("index");
    detailSlider.slideTo(3 * target_index - 2);
  }

  if ($(".main_visual_swiper").length) {
    //メイン画像
    let main_visual_swiper = new Swiper(".main_visual_swiper", {
      effect: "fade",
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 900,
      noSwiping: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction", // 枚数表示
        // clickable: true,
      },
    });
  }

  //TOPページ商品スライダー
  var swiper = new Swiper(".mySwiper", {
    loop: false,
    spaceBetween: 20,
    slidesPerView: 2.5,
    freeMode: true,
    autoHeight: false,
  });

  var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
});

// ハンバーガーメニュー展開
$(document).on("click", ".menuToggle", function () {
  $("#drawer").toggleClass("open");
  $("#overlay").toggleClass("open");
  $("body").toggleClass("open");
  return false;
});

// $(document).on('click', '.menuClose', function () {
//   $(".hdrSearch__wrap.gNav__icon").slideUp();
//   $('#drawer').removeClass('open');
//   // $('#overlay').removeClass('open');
//   $('body').removeClass('open');
//   //$('.js-searchTrigger').removeClass('open');
//   return false;
// });

$(document).on("click", ".menuClose", function () {
  $("#drawer").removeClass("open");
  $("#overlay").removeClass("open");
  $("body").removeClass("open");
  return false;
});

// SPのみアコーディオン
$(document).on("click", ".sp-toggle", function () {
  var windowWidth = $(window).width();
  if (windowWidth < 768) {
    $(this).next("ul").slideToggle();
    $(this).toggleClass("open");
    return false;
  }
});

$(document).on("click", ".js-searchTrigger", function () {
  // $(this).next().slideToggle();
  $(".hdrSearch__wrap.gNav__icon").slideToggle("300");
  // $('body').toggleClass('open');
  //$('.js-searchTrigger').toggleClass('open');
  return false;
});

$(document).on("click", ".hdrSearch_close", function () {
  $(".hdrSearch__wrap.gNav__icon").slideToggle("300");
  return false;
});

// ナビゲーション　子要素展開
$(function () {
  var ua = navigator.userAgent;
  // タブレット・スマートフォン時
  if (
    ((ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
      ua.indexOf("Mobile") > 0) ||
    ua.indexOf("iPad") > 0
  ) {
    $(".hasChildren > a")
      .on("mouseenter touchstart", function () {
        $(this).toggleClass("open");
        $(this).next("ul,.megaMenu").toggleClass("open");
        return false;
      })
      .on("mouseleave touchend", function () {
        return false;
      });
    $(".hasChildren .hasChildren--close > a").on(
      "mouseenter touchstart",
      function () {
        $(this).parents("ul").removeClass("open").prev("a").removeClass("open");
        return false;
      }
    );
  } else {
    // PC時
    $(".hasChildren").hover(
      function () {
        $(this).children("a").addClass("open");
        $(this).children("ul,.megaMenu").addClass("open");
      },
      function () {
        $(this).children("a").removeClass("open");
        $(this).children("ul,.megaMenu").removeClass("open");
      }
    );
  }
});

$(document).on(
  "click",
  ".hasChildren--click > a,.hasChildren--click > span",
  function () {
    if (dropState == false) {
      $(this).addClass("open");
      $(this).next("ul").addClass("open");
      $(this).next("ul").slideDown();
      dropState = true;
    } else {
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $(this).next("ul").removeClass("open");
        $(this).next("ul").slideUp();
      } else {
        $(this)
          .parents("li")
          .parents("ul")
          .parents(".gNav")
          .find(".hasChilds > span")
          .removeClass("open");
        $(this)
          .parents("li")
          .parents("ul")
          .parents(".gNav")
          .find(".hasChilds > span")
          .next("ul")
          .removeClass("open");
        $(this)
          .parents("li")
          .parents("ul")
          .parents(".gNav")
          .find(".hasChilds > span")
          .next("ul")
          .slideUp(0);
        $(this).addClass("open");
        $(this).next("ul").addClass("open");
        $(this).next("ul").slideDown();
      }
    }
    return false;
  }
);

// SPヘッダーD　カテゴリーナビ
$(document).on("click", ".hdrCatMenu--toggle", function () {
  if ($(this).hasClass("open")) {
    $(this).removeClass("open");
    $(this).next("ul").removeClass("open");
    $(this).next("ul").slideUp();
  } else {
    $(".hdrCatMenu--toggle.open").next("ul").hide();
    $(".hdrCatMenu--toggle.open").next("ul").removeClass("open");
    $(".hdrCatMenu--toggle.open").removeClass("open");
    $(this).addClass("open");
    $(this).next("ul").addClass("open");
    $(this).next("ul").slideDown();
  }
  return false;
});

// ナビ固定
// $(function () {
//   var target = $(".hdrFixed");
//   if ($(".hdrFixed").length) {
//     var h = target.height();
//     var h_top = target.offset().top;
//     target.after('<div class="h_box"></div>');
//     $(".h_box").height("0");
//     $(window).on('load scroll', function (event) {
//       var scroll = $(window).scrollTop();
//       if (scroll >= h_top) {
//         target.css({
//           position: 'fixed',
//           top: '0px',
//           width: '100%',
//           'z-index': '998'
//         });
//         $(".h_box").height(h);
//       } else {
//         target.css({
//           position: ''
//         });
//         $(".h_box").height("0");
//       }
//     });
//   }
// });

function sNavIn(_this) {
  var windowWidthMinus = document.documentElement.clientWidth * -1;
  $(_this).addClass("open");
  $(".menuBg--close").addClass("open");
  $(_this).css({
    left: 0,
  });
}

function sNavOut(_this) {
  var windowWidthMinus = document.documentElement.clientWidth * -1;
  $(_this).removeClass("open");
  $(".menuBg--close").removeClass("open");
  $(_this).css({
    left: windowWidthMinus,
  });
}

// タブ切り替え
$(function () {
  $(".tabSwitch > li ").click(function () {
    if (!$(this).hasClass("active")) {
      $(this).parents(".tabSwitch").find("li").removeClass("active");
      $(this).addClass("active");

      var tabNum = $(this).index();
      $(this).parents(".tab").find(".tabContents").find(".tabContent").hide();
      $(this)
        .parents(".tab")
        .find(".tabContents")
        .find(".tabContent")
        .eq(tabNum)
        .fadeIn("500");

      $(".tabSwitch")
        .removeClass("current_1")
        .removeClass("current_2")
        .removeClass("current_3")
        .removeClass("current_4");
      $(".tabSwitch").addClass("current_" + (tabNum + 1));
    }
  });
});

if ($("body").hasClass("productPage")) {
  //カートボタン等の位置調整
  $(window).on("load scroll", function () {
    var currentPos = $(this).scrollTop();
    scrollHeight = $(document).height();
    scrollPosition = $(window).height() + $(window).scrollTop();
    footHeight = $("footer").innerHeight();

    if (currentPos > 1300) {
      $("body").addClass("isCartFixed");
      setPriceValue_now();
    } else {
      $("body").removeClass("isCartFixed");
      setPriceValue_now();
      reset_footer_cartButton();
    }

    if (currentPos > 100) {
      $(".product--btns").addClass("animated");
      $(".product--btns2").addClass("animated");
    } else {
      $(".product--btns").removeClass("animated");
      $(".product--btns2").removeClass("animated");
    }
  });

  //カートボタンをfixedにした際のページ崩れを防ぐためにカートボタンのコンテナ要素に高さを付与
  function setButtonWrapperHeight() {
    let button_container = $(".product__info-wrapper.grid__item");
    let container_height = button_container.outerHeight();
    if (container_height > 50 && window.innerWidth <= 749) {
      button_container.css("height", container_height);
    } else {
      button_container.css("height", '');
    }
  }

  $(window).on("load", setButtonWrapperHeight);
  $(window).on("resize", setButtonWrapperHeight);

// 固定カートボタン横の価格表記
function setPriceValue() {
  window.addEventListener("DOMContentLoaded", (event) => {
    const saleElement = document.querySelector(".price-item--sale");
    const regularElement = document.querySelector(".price-item--regular .price_value");
    
    let item_price = "";

    // テキストを取得した後、.replace("TAX IN", "") で文字を削除し、.trim()で空白除去
    if (saleElement) {
      item_price = saleElement.textContent.replace("TAX IN", "").trim();
    } else if (regularElement) {
      item_price = regularElement.textContent.replace("TAX IN", "").trim();
    }

    setTimeout(function () {
      const target = document.querySelector("#js-item_price");
      if (target) target.textContent = item_price;
    }, 0);
  });
}

setPriceValue();

function setPriceValue_now() {
  const saleElement = document.querySelector(".price-item--sale");
  const regularElement = document.querySelector(".price-item--regular .price_value");

  let item_price = "";

  // こちらも同様に TAX IN を削除
  if (saleElement) {
    item_price = saleElement.textContent.replace("TAX IN", "").trim();
  } else if (regularElement) {
    item_price = regularElement.textContent.replace("TAX IN", "").trim();
  }

  setTimeout(function () {
    const target = document.querySelector("#js-item_price");
    if (target) target.textContent = item_price;
  }, 0);
}

  //フッタ追従ボタン周りの調整
  //初期状態ではDIVでカバーしておいてカートインを起動させない。
  //一回クリックするとカバーのDIVを消してカートイン出来るようにする
  //同時にバリエーション価格モーダルを出す
  function footer_cartButtonToggle() {
    $(".product-form__buttons .product-form__buttons_cover").click(function () {
      $(this).addClass("is-hidden");
      $("body").addClass("overflow-hidden footer_cartButton--open");
    });
  }
  footer_cartButtonToggle();

  //ページ上部に戻った際にボタンをリセットする
  function reset_footer_cartButton() {
    $(".product-form__buttons .product-form__buttons_cover").removeClass(
      "is-hidden"
    );
    $("body").removeClass("overflow-hidden");
  }

  $(".product-form__buttons .product-form__buttons_cover").click(function () {
    $(
      ".isCartFixed .product__info-wrapper.grid__item > .product__info-container .footer_sticky_container"
    ).toggleClass("is-open");
    $(".footer_sticky_container_back").toggleClass("is-hidden");
    if ($("body").hasClass("product-review--open")) {
      console.log("レビューが開いてます");
      $("body").removeClass("product-review--open");
      $(
        '[id^="shopify-section-template"][id$="mxpr-product-reviews"]'
      ).removeClass("is-open");
      $(".product-review___back").removeClass("is-open");
    }
  });

  $(".footer_sticky_container__close img").click(function () {
    $(
      ".isCartFixed .product__info-wrapper.grid__item > .product__info-container .footer_sticky_container"
    ).toggleClass("is-open");
    $(".product-form__buttons_cover").toggleClass("is-hidden");
    $(".footer_sticky_container_back").toggleClass("is-hidden");
    $("body").removeClass("overflow-hidden footer_cartButton--open");
  });

  $(".footer_sticky_container_back").click(function () {
    $(
      ".isCartFixed .product__info-wrapper.grid__item > .product__info-container .footer_sticky_container"
    ).toggleClass("is-open");
    $(".product-form__buttons_cover").toggleClass("is-hidden");
    $(".footer_sticky_container_back").toggleClass("is-hidden");
    $("body").removeClass("overflow-hidden footer_cartButton--open");
  });
}

//バリエーションが選択で価格が変わった場合、フッタ追従ボタンの横の価格を書き換える
// const target = document.querySelector('.price-item--regular');
//
// const observer = new MutationObserver(records => {
//   console.log('changed');
//   setPriceValue();
// })
//
// observer.observe(target, {
//   childList: true
// });

// // スクロールボタン
// $(function () {
//   if ($(".mainSliderSec").length || $(".mainVisual").length) {
//     if ($(".mainVisual--hero").length) {
//       var position = $(window).height();
//     } else if ($(".mainSliderSec").length) {
//       var position = $(".mainSliderSec + * ").offset().top;
//     } else {
//       var position = $(".mainVisual + * ").offset().top;
//     }
//     $("#scrollBtn").click(function () {
//       $("html,body").animate(
//         {
//           scrollTop: position // さっき変数に入れた位置まで
//         },
//         {
//           queue: false // どれくらい経過してから、アニメーションを始めるか。キュー[待ち行列]。falseを指定すると、キューに追加されずに即座にアニメーションを実行。
//         }
//       );
//       return false;
//     });
//   }
// });

// テキスト横スクロール
var spSwiperDone = false;
$(window).on("load resize", function (event) {
  if (
    window.innerWidth < 992 &&
    spSwiperDone == false &&
    $(".spSwiper").length
  ) {
    $(".spSwiper").slick({
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      variableWidth: true,
      touchMove: true,
      swipeToSlide: true,
      infinite: false,
    });

    spSwiperDone = true;
  }
});

//ヘッダアプリToast
$(".hdrToast_close").click(function () {
  $("body").removeClass("show_hdrToast");
  $(".hdrToast").fadeOut();
});

// ヘッダアプリ フェードアニメーション
// $(function () {
//   $(".hdrToast ul li:not(:first-child)").hide();
//   setInterval(function () {
//     $(".hdrToast ul li:first-child")
//       .fadeOut("slow")
//       .next("li")
//       .fadeIn("slow")
//       .end()
//       .appendTo(".hdrToast ul");
//   }, 8000);
// });

//背景に応じて、ロゴ・アイコンの色を変更する
//色の変更を適用したいセクションに sec_colorSwitch を付与する（#main 配下の要素に限る）
//data-theme の値で色が変わる
//bg-pri 場合 ロゴが白 white の場合ロゴが色付き
function initObserveSectionTheme() {
  window.addEventListener("scroll", function (e) {
    var currentTopPosition = document.querySelector("html").scrollTop;
    $("#main .sec_colorSwitch").each(function (i, ele) {
      var start = $(ele).offset().top;
      var end = start + $(ele).height();
      if (start - 72 < currentTopPosition && currentTopPosition < end) {
        // ヘッダメニューフルテーマ設定
        $("html").removeClass("bg-pri");
        if ($(ele).data("theme") === "white") {
        } else {
          if (
            $("body").hasClass("home") ||
            $("body").hasClass("accountPage") ||
            $("body").hasClass("collection")
          ) {
            !$("html").hasClass("remove") ? $("html").addClass("bg-pri") : null;
          }
        }
      }
    });
  });
}

initObserveSectionTheme();

//ページTOPへ戻るボタン
$(".toTop--circle").on("click", function (e) {
  e.preventDefault();
  $("body.home html").addClass("bg-pri");
  $("html, body").animate({
    scrollTop: 0,
  });
});

//カラーチップ
$(function () {
  $(".product--colorchip .color-img > li").click(function () {
    var tab_wrap = $(this).parents(".product--colorchip");
    var tab_btn_item = $(tab_wrap).find(".color-img > li");
    var index = $(tab_btn_item).index(this);

    $(this)
      .parents(".product--colorchip")
      .find(".color-img > li")
      .removeClass("active");
    $(this)
      .parents(".product--colorchip")
      .find(".color-text > ul > li")
      .removeClass("active");
    $(this).addClass("active");
    $(this)
      .parents(".product--colorchip")
      .find(".color-text > ul > li")
      .eq(index)
      .addClass("active");
  });
});

//マイページ都道府県日本語変換
window.onload = function () {
  if ($(".customer.account").length > 0) {
    var prefectures_conversion = {
      Aichi: "愛知県",
      Akita: "秋田県",
      Aomori: "青森県",
      Chiba: "千葉県",
      Ehime: "愛媛県",
      Fukui: "福井県",
      Fukuoka: "福岡県",
      Fukushima: "福島県",
      Gifu: "岐阜県",
      Gunma: "群馬県",
      Hiroshima: "広島県",
      Hokkaido: "北海道",
      Hyogo: "兵庫県",
      Ibaraki: "茨城県",
      Ishikawa: "石川県",
      Iwate: "岩手県",
      Kagawa: "香川県",
      Yamanashi: "山梨県",
      Yamaguchi: "山口県",
      Kochi: "高知県",
      Kumamoto: "熊本県",
      Kyoto: "京都府",
      Mie: "三重県",
      Yamagata: "山形県",
      Miyazaki: "宮崎県",
      Nagano: "長野県",
      Nagasaki: "長崎県",
      Nara: "奈良県",
      Niigata: "新潟県",
      Oita: "大分県",
      Okayama: "岡山県",
      Okinawa: "沖縄県",
      Osaka: "大阪府",
      Saga: "佐賀県",
      Saitama: "埼玉県",
      Shiga: "滋賀県",
      Shimane: "島根県",
      Shizuoka: "静岡県",
      Tochigi: "栃木県",
      Tokushima: "徳島県",
      Tottori: "鳥取県",
      Toyama: "富山県",
      Tokyo: "東京都",
      Miyagi: "宮城県",
      Wakayama: "和歌山県",
      Kanagawa: "神奈川県",
      Kagoshima: "鹿児島県",
    };
    $(".customer.account form .prefectures select option").each(function () {
      for (key in prefectures_conversion) {
        if (key == $(this).text()) {
          $(this).text(prefectures_conversion[key]);
        }
      }
    });
  }
};

//レビューアプリ
if ($("body").hasClass("productPage")) {
  let product_review_handler =
    '[id^="shopify-section-template"][id$="mxpr-product-reviews"]';

  window.addEventListener("DOMContentLoaded", (event) => {
    document
      .querySelector(product_review_handler)
      .insertAdjacentHTML(
        "afterbegin",
        '<span class="product-review__close"><img src="https://cdn.shopify.com/s/files/1/0660/0314/0846/t/3/assets/arrow_down_03.png" alt="CLOSE"></span>' +
          '<div class="product-review_header"><h2 class="title">レビュー投稿で【 30pt 】獲得!!</h2><p class="text">注意事項<br>※承認されたレビューのみポイント獲得対象となります。<br>※レビューの承認には、投稿後2~3営業日ほどお時間をいただきます。<br>※非承認レビューへの通知はございませんのでご了承ください。</p></div>'
      );
    document
      .querySelector(product_review_handler)
      .insertAdjacentHTML(
        "afterend",
        '<div class="product-review___back">\n' + "</div>"
      );
  });

  //レビューアプリ開閉ボタン
  $(".product-review__button").on("click", function () {
    $("body").toggleClass("product-review--open overflow-hidden");
    $(product_review_handler).toggleClass("is-open");
    $(".product-review___back").toggleClass("is-open");
  });

  $(document).on("click", ".product-review__close", function () {
    $("body").removeClass("product-review--open overflow-hidden");
    $(product_review_handler).removeClass("is-open");
    $(".product-review___back").removeClass("is-open");
  });

  $(document).on("click", ".product-review___back", function () {
    $("body").removeClass("product-review--open overflow-hidden");
    $(product_review_handler).removeClass("is-open");
    $(".product-review___back").removeClass("is-open");
  });
}

//商品詳細のバリエーション
$(document).ready(function () {
  if ($(".product .product-form__input input[type='radio']:checked").length) {
    var color_value = $(
      ".product .product-form__input input[type='radio']:checked"
    )
      .parent()
      .find("img")
      .attr("data-color_text");
    var color_cord = $(
      ".product .product-form__input input[type='radio']:checked"
    )
      .parent()
      .find("img")
      .attr("data-color_cord");

    $(".select_variant_area").css("display", "block");
    $(".select_variant_area .color_area").css("background", color_cord);
    $(".select_variant_area .color_text").text(color_value);
    //クリックイベント
    $(".product .product-form__input input").click(function () {
      var color_value = $(this).parent().find("img").attr("data-color_text");
      var color_cord = $(this).parent().find("img").attr("data-color_cord");

      $(".select_variant_area").css("display", "block");
      $(".select_variant_area .color_area").css("background", color_cord);
      $(".select_variant_area .color_text").text(color_value);
    });
  }
});

//wow
new WOW().init();

//scrollreveal
//https://scrollrevealjs.org/
if (typeof ScrollReveal !== "undefined") {
  ScrollReveal().reveal(".js-fadeUp", {
    opacity: 0,
    duration: 1400,
    origin: "bottom",
    distance: "20px",
    reset: false,
    delay: 500,
    viewFactor: 0.2,
    viewOffset: { top: 200 },
  });
}

//最近見た商品スライダーが0の場合非表示等
// window.addEventListener('DOMContentLoaded', (event) => {
//   if ($(".recentlySlider .swiper-wrapper .swiper-slide").length == 0) {
//     $('.recentlySlider ').html('<p class="text-center">最近見た商品はありません</p>');
//   }
// });

//フィルターアプリ文字列置換
const target = document.querySelector(".active-facets");
if (target != null) {
  // オブザーバーの作成
  const observer = new MutationObserver((records) => {
    // 変化が発生したときの処理
    active_facets_textReplace();
  });

  // 監視の開始
  observer.observe(target, {
    childList: true,
  });
}

// 検索タグのテキストを置換する関数（アイテム: カテゴリー: 在庫状況: 等を削除する）
function active_facets_textReplace() {
  $(".active-facets__button-inner").each(function () {
    let txt = $(this).html();
    $(this).html(
      txt
        .replace("アイテム:", "")
        .replace("カテゴリー:", "")
        .replace("在庫状況:", "")
    );
  });
}

// ページバック時、ページリロード時にテキスト置換を実行
window.addEventListener("pageshow", function (event) {
  active_facets_textReplace();
});

//レビューアプリの星を置き換え
$(".mxpr-summary__write-review").click(function () {
  $("#mxpr-form__rating option").each(function () {
    let txt = $(this).html();
    $(this).html(
      txt
        .replace("⭐️⭐️⭐️⭐️⭐️", "★★★★★")
        .replace("⭐️⭐️⭐️⭐️", "★★★★")
        .replace("⭐️⭐️⭐️", "★★★")
        .replace("⭐️⭐️", "★★")
        .replace("⭐", "★")
    );
  });
});
